import React, {ReactNode, useEffect} from 'react';

import {Helmet} from 'react-helmet-async';

import {ErrorBoundary} from 'components/ui-kit/ErrorBoundary';
import {LABELS} from 'core/constants/labels';
import {setHeaderTitle} from 'models/header';

interface PageProps {
    children: ReactNode;
    title?: string;
    controls?: ReactNode;
}

export const Page = ({children, title, controls}: PageProps) => {
    useEffect(() => {
        setHeaderTitle({title: title ?? '', controls});
    }, [title, controls]);

    return (
        <>
            <Helmet>
                <title>{title || LABELS.name}</title>
            </Helmet>

            <ErrorBoundary>{children}</ErrorBoundary>
        </>
    );
};
